import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useEnterExitAnimation } from './useEnterExitAnimation.js';
import { ZINDEX } from '../static/constants.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useOverlay = function useOverlay(_ref) {
  var transition = _ref.transition,
    animationFallBackTimeMs = _ref.animationFallBackTimeMs,
    visible = _ref.visible,
    height = _ref.height,
    zIndex = _ref.zIndex,
    onClick = _ref.onClick;
  var _useEnterExitAnimatio = useEnterExitAnimation({
      initialProps: {
        opacity: 0
      },
      enterProps: {
        opacity: 1
      },
      animationOn: visible,
      transition: transition,
      animationFallBackTimeMs: animationFallBackTimeMs
    }),
    transitionProps = _useEnterExitAnimatio.transitionProps,
    shouldRenderOverlay = _useEnterExitAnimatio.shouldRender;
  return {
    overlayProps: _objectSpread(_objectSpread(_objectSpread({}, transitionProps), height !== undefined && height !== null && {
      height: height
    }), {}, {
      zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : ZINDEX.FLOATING,
      onClick: onClick,
      touchAction: 'none'
    }),
    shouldRenderOverlay: shouldRenderOverlay
  };
};

export { useOverlay };
//# sourceMappingURL=useOverlay.js.map
